import { Dispatch, SetStateAction } from 'react'

import { ShotlistsService } from '@/services/shotlist.service'

import { ILanguage } from '@/types/task.interface'
import { ISelectedPlatform, TPlatformValue } from '@/types/uploadForm.interface'

import { resetPlatformHeaderState } from '../helpers/resetPlatformHeaderState'

export const stopTranscription = async ({
	taskId,
	clearWatch,
	selectedPlatform,
	setSelectedPlatformList,
	setSelectedTranscribingLang,
	setIsTranscribing
}: {
	taskId: string
	clearWatch?: () => void
	selectedPlatform: TPlatformValue | null
	setSelectedPlatformList: Dispatch<SetStateAction<ISelectedPlatform[]>>
	setSelectedTranscribingLang: Dispatch<SetStateAction<ILanguage | null>>
	setIsTranscribing?: Dispatch<SetStateAction<boolean>>
}) => {
	if (!taskId) return

	clearWatch?.()

	try {
		const result = await ShotlistsService.stopTranscribing(taskId)

		if (result.success) {
			resetPlatformHeaderState({ selectedPlatform, setSelectedPlatformList })
			setSelectedTranscribingLang(null)
		}
	} catch (error) {
		console.log(error)
	} finally {
		setIsTranscribing?.(false)
	}
}
